import React, { useState, useContext } from "react";
import { ClientContext } from "../../context/Client/ClientContext";
import { useNavigate } from "react-router-dom";

const SearchByKeyword = ({ resetSearchByBtnState }) => {
  const [disabled, setDisabled] = useState(true);
  const [matchAny, setMatchAny] = useState("true");
  const [placeHolder, setPlaceHolder] = useState(true);

  const {
    getClientsByKeywords,
    clearSelectedClient,
    hideClientList,
    isClientSelected,
    selectedClient,
    setKeywords,
    keywords,
    setKeysArr,
    clientListEmpty,
  } = useContext(ClientContext);

  const navigate = useNavigate();

  const parseKeywords = (value) => {
    return value
      .split(",")
      .map((key) => key.trim().replace(/,/g, ""))
      .filter((key) => key.length > 0);
  };

  const handleInputChange = (e) => {
    const value = e.target.value;

    setKeywords(value);
    setPlaceHolder(true);
    setDisabled(value.trim().length <= 2);

    clearSelectedClient();
    hideClientList();
  };

  const handleOnclickKeywordHandler = () => {
    setPlaceHolder(true);
  };

  const runKeywordSearch = async (matchValue = matchAny) => {
    const keys = parseKeywords(keywords);

    if (keys.length === 0) {
      return;
    }

    setKeysArr(keys);

    await getClientsByKeywords(keys, matchValue);

    setKeywords(keys.join(", "));
    setPlaceHolder(false);
  };

  const handleNextBtnClick = async () => {
    if (isClientSelected) {
      navigate(`/client/${selectedClient.id}`);
      return;
    }

    await runKeywordSearch(matchAny);
  };

  const handleBackClick = () => {
    if (isClientSelected) {
      clearSelectedClient();
    } else {
      setKeywords("");
      hideClientList();
      resetSearchByBtnState();
    }
  };

  const handleKeyup = (e) => {
    if (e.key === "Enter") {
      handleNextBtnClick();
    }
  };

  const handleRadioChanged = async (value) => {
    setMatchAny(value);

    if (keywords.trim().length > 2 && keywords.includes(",")) {
      await runKeywordSearch(value);
    }
  };

  return (
    <div className="gog-search-input-panel">
      <div className="gog-field">
        <label>Keywords</label>

        <input
          autoFocus
          type="text"
          value={keywords}
          placeholder="Example: pizza, bakery, gifts"
          onClick={handleOnclickKeywordHandler}
          onChange={handleInputChange}
          onKeyUp={handleKeyup}
        />

        {placeHolder && (
          <small>
            Enter keywords or multi-word keywords separated by commas.
          </small>
        )}

        {clientListEmpty && !placeHolder && (
          <div className="gog-form-message error">No results found.</div>
        )}
      </div>

      <div className="gog-keyword-options-row">
        <div className="gog-radio-group">
          <span>Match</span>

          <label>
            <input
              id="matchAny"
              type="radio"
              name="anyOrAllRadio"
              checked={matchAny === "true"}
              value="true"
              onChange={(e) => handleRadioChanged(e.target.value)}
            />
            <i />
            <strong>Any</strong>
          </label>

          <label>
            <input
              id="matchAll"
              type="radio"
              name="anyOrAllRadio"
              checked={matchAny === "false"}
              value="false"
              onChange={(e) => handleRadioChanged(e.target.value)}
            />
            <i />
            <strong>All</strong>
          </label>
        </div>

        <div className="gog-form-actions inline">
          <button type="button" className="gog-light-btn" onClick={handleBackClick}>
            Back
          </button>

          <button
            type="button"
            className="gog-primary-btn"
            disabled={disabled && !isClientSelected}
            onClick={handleNextBtnClick}
          >
            {!isClientSelected ? "Search" : "Next"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default SearchByKeyword;